import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
const changeStatusMutation = gql`mutation update_second_hand_supplies_orders(
  $id:uuid!,
  $second_hand_supplies_orders: second_hand_supplies_orders_set_input!,
  $second_hand_supplies_order_notes: second_hand_supplies_order_notes_insert_input!
){
  update_second_hand_supplies_orders_by_pk(pk_columns:{id:$id}, _set: $second_hand_supplies_orders){
    id
  }
  insert_second_hand_supplies_order_notes_one(object: $second_hand_supplies_order_notes){
    id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class ChangeStatusService {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
/* ------------------------------ Change Status ----------------------------- */
  changeStatus(
    id: string,
    second_hand_supplies_orders: any,
    second_hand_supplies_order_notes: any
  ): Promise<any> {
    return this.apollo.use('external').mutate({
      mutation: changeStatusMutation,
      variables:{
        id,
        second_hand_supplies_orders,
        second_hand_supplies_order_notes
      }
    }).toPromise()
  }
}
